import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import Layout from '../../components/layout/Layout';
import DeviceHub from '../deviceHub/DeviceHub';
import HealthCheck from '../healthcheck/HealthCheck';
import Provisioning from '../provisioning/Provisioning';

// Devices 허브 (결정 ③④ · 12.01-D008, docs/V1_ADMIN_SCREEN_REVIEW.md §5-2)
// 탭은 URL(?tab=) 과 연결, 선택한 탭만 mount — Provisioning 의 Redux peer 액션이 다른 탭과 겹치지 않게
const TABS = [
  { id: 'commands', label: '기기·명령', render: (user) => <DeviceHub user={user} embedded /> },
  { id: 'health', label: '상태', render: (user) => <HealthCheck user={user} embedded /> },
  { id: 'wg', label: 'WG·OTA', render: (user) => <Provisioning user={user} embedded /> },
];

function DevicesHub({ user }) {
  const [params, setParams] = useSearchParams();
  const current = TABS.find((t) => t.id === params.get('tab')) || TABS[0];
  return (
    <Layout title="Devices" user={user}>
      <Box sx={{ px: { xs: 1, sm: 2 }, pt: 1 }}>
        <Tabs
          value={current.id}
          onChange={(_, v) => setParams({ tab: v }, { replace: true })}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{ borderBottom: 1, borderColor: 'divider', '& .MuiTab-root': { textTransform: 'none', fontWeight: 600 } }}
        >
          {TABS.map((t) => (
            <Tab key={t.id} value={t.id} label={t.label} />
          ))}
        </Tabs>
      </Box>
      <Box key={current.id}>{current.render(user)}</Box>
    </Layout>
  );
}

export default DevicesHub;
